import { render } from "./OrderReviewTermsAndConditions.vue?vue&type=template&id=4fc78143"
import script from "./OrderReviewTermsAndConditions.vue?vue&type=script&lang=js"
export * from "./OrderReviewTermsAndConditions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__